import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import IconButton from "components/common/IconButton";
import ImageComponent from "components/common/Image";

const ConnectorsList = ({ loading, onDeleteClick ,data}) => {
  const columns = [
    {
      field: "city",
      headerName: "City",
    },
    {
      field: "title",
      headerName: "Coupon title",
    },
    {
      field: "sub_title",
      headerName: "Coupon sub_title",
    },
    {
      field: "description",
      headerName: "Coupon description",
    },
    {
      field: "coupon_code",
      headerName: "Coupon code",
    },
    {
      field: "type",
      headerName: "Coupon type",
    },
    {
      field: "offer",
      headerName: "Offer",
    },
    {
      field: "start_date",
      headerName: "Start date",
    },
    {
      field: "expiry_date",
      headerName: "Expiry date",
    },
    {
      field: "coupon_status",
      headerName: " Coupon Status",
    },

    {
      field: "action",
      headerName: "Action",
      valueGetter: (v, d) => {
        
        return (
          <>
            {
              <>
                <IconButton
                  aria-label="delete"
                  onClick={() => onDeleteClick(d.id)}
                  sx={{
                    color: "green",
                  }}
                >
                  <ImageComponent src="delete-icon.svg" />
                </IconButton>
              </>
            }
          </>
        );
      },
    },
  ];
  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(ConnectorsList);
